// Live upscaler + pipeline settings — pure module (NO firebase import). The
// Firestore sync lives in src/data/upscaleConfigSync.js and calls setUpscaleConfig().
//
// KEEP DEFAULTS IN SYNC with backend/shared/upscaleConfig.js.

export const UPSCALE_DEFAULTS = {
  poll: {
    stallMs: 300000,
    capMs: 3600000,
    reportMs: 2500,
  },
  models: {
    supir: {
      mode: 'supir-only',
      steps: 24,
      cfg: 2.0,
      restore: 4.0,
      churn: 0,
      snoise: 1.0,
      seed: 123,
      refineDenoise: 0.15,
      positive: 'natural color photograph, realistic, true to life, in focus, sharp',
      negative: 'painting, illustration, cgi, 3d render, cartoon, drawing, over-detailed, '
        + 'extra water droplets, fake spray, hallucinated detail, oversharpened, halos, '
        + 'plastic, waxy, deformed, blurry, out of focus',
    },
    'ultimate-sd': {
      denoise: 0.2,
      steps: 18,
      tile: 1024,
    },
  },
};

let _cfg = UPSCALE_DEFAULTS;
const listeners = new Set();

function deepMerge(base, remote) {
  if (!remote || typeof remote !== 'object') return base;
  const out = Array.isArray(base) ? [...base] : { ...base };
  for (const k of Object.keys(base)) {
    const bv = base[k];
    const rv = remote[k];
    out[k] = bv && typeof bv === 'object' && !Array.isArray(bv) ? deepMerge(bv, rv) : (rv == null ? bv : rv);
  }
  for (const k of Object.keys(remote)) if (!(k in out)) out[k] = remote[k];
  return out;
}

export function upscaleConfig() { return _cfg; }

export function setUpscaleConfig(remote) {
  _cfg = deepMerge(UPSCALE_DEFAULTS, remote);
  listeners.forEach((fn) => { try { fn(_cfg); } catch { /* ignore */ } });
  return _cfg;
}

export function subscribeUpscaleConfig(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
